<template src="@/templates/disclaimer/disclaimer.html"></template>

<script>
export default {
  name: "Disclaimer",
};
</script>

<style scoped>
#divDisclaimer p {
  color: red;
  font-size: 10px;
  text-align: left;
  text-transform: none;
  margin: 0;
}
</style>
